{
  "name": "itria-webapp",
  "private": true,
  "version": "0.2.6",
  "type": "module",
  "engines": {
    "node": ">=24",
    "bun": ">=1.3.2"
  },
  "packageManager": "bun@1.4.0",
  "scripts": {
    "dev": "vite",
    "build": "tsc -b && vite build",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "preview": "vite preview",
    "check:type": "tsc --noEmit",
    "check": "bun run lint && bun run check:type",
    "prepare": "husky || true",
    "notify:test": "bun --env-file=.env run ./scripts/notifications-test.ts",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "release:production": "node scripts/tag-release.cjs production",
    "release:patch": "node scripts/tag-release.cjs production --patch",
    "release:minor": "node scripts/tag-release.cjs production --minor",
    "release:major": "node scripts/tag-release.cjs production --major"
  },
  "dependencies": {
    "@assistant-ui/react": "^0.15.17",
    "@assistant-ui/react-markdown": "^0.14.13",
    "@checkr/web-sdk": "0.0.60",
    "@fontsource/poppins": "^5.3.0",
    "@hookform/resolvers": "5.9.1",
    "@ncdai/react-wheel-picker": "^1.2.3",
    "@radix-ui/react-accordion": "1.2.20",
    "@radix-ui/react-alert-dialog": "1.1.23",
    "@radix-ui/react-aspect-ratio": "1.1.15",
    "@radix-ui/react-avatar": "1.2.6",
    "@radix-ui/react-checkbox": "1.3.11",
    "@radix-ui/react-dialog": "1.1.23",
    "@radix-ui/react-dropdown-menu": "2.1.24",
    "@radix-ui/react-label": "2.1.15",
    "@radix-ui/react-navigation-menu": "1.2.22",
    "@radix-ui/react-popover": "1.1.23",
    "@radix-ui/react-progress": "1.1.16",
    "@radix-ui/react-radio-group": "1.4.7",
    "@radix-ui/react-scroll-area": "1.2.18",
    "@radix-ui/react-select": "2.3.7",
    "@radix-ui/react-separator": "1.1.15",
    "@radix-ui/react-slider": "1.4.7",
    "@radix-ui/react-slot": "1.3.3",
    "@radix-ui/react-switch": "1.3.7",
    "@react-google-maps/api": "2.20.8",
    "@sentry/react": "10.73.0",
    "@sentry/vite-plugin": "5.4.0",
    "@stripe/react-stripe-js": "6.8.2",
    "@stripe/stripe-js": "9.15.0",
    "@tailwindcss/vite": "4.3.3",
    "@tanstack/react-query": "5.102.8",
    "@tanstack/react-router": "1.170.32",
    "@tanstack/react-router-devtools": "1.167.1",
    "@tanstack/router-vite-plugin": "1.167.35",
    "@vis.gl/react-google-maps": "1.9.0",
    "axios": "1.20.0",
    "chart.js": "4.5.1",
    "class-variance-authority": "0.7.1",
    "clsx": "2.1.1",
    "cmdk": "1.1.1",
    "date-fns": "4.4.0",
    "embla-carousel-autoplay": "8.6.0",
    "embla-carousel-react": "8.6.0",
    "firebase": "12.18.0",
    "framer-motion": "13.1.1",
    "i": "0.3.7",
    "input-otp": "1.5.0",
    "lodash": "4.18.1",
    "lottie-react": "3.1.1",
    "lucide-react": "1.39.0",
    "moment": "2.30.1",
    "next-themes": "0.4.6",
    "radix-ui": "^1.6.7",
    "react": "19.2.8",
    "react-chartjs-2": "5.3.1",
    "react-creditcard": "1.1.2",
    "react-day-picker": "10.0.1",
    "react-dom": "19.2.8",
    "react-error-boundary": "6.1.4",
    "react-hook-form": "7.87.0",
    "react-icons": "5.7.0",
    "react-payment-inputs": "1.2.0",
    "react-phone-number-input": "3.4.18",
    "react-rating": "2.0.5",
    "react-toastify": "11.1.0",
    "recharts": "3.10.1",
    "remark-gfm": "^4.0.1",
    "sonner": "2.0.8",
    "tailwind-merge": "3.6.0",
    "tailwindcss": "4.3.3",
    "tw-shimmer": "^0.4.12",
    "usehooks-ts": "3.1.1",
    "vaul": "1.1.2",
    "zod": "4.5.4",
    "zustand": "5.0.15"
  },
  "devDependencies": {
    "@commitlint/cli": "21.2.2",
    "@commitlint/config-conventional": "21.2.2",
    "@eslint/js": "10.0.1",
    "@tanstack/router-plugin": "1.168.35",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@types/node": "26.4.1",
    "@types/react": "19.2.18",
    "@types/react-dom": "19.2.5",
    "@types/react-payment-inputs": "1.1.4",
    "@vitejs/plugin-react": "6.1.1",
    "@vitest/coverage-v8": "^4.1.11",
    "eslint": "10.9.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.6",
    "eslint-plugin-react-hooks": "7.1.1",
    "eslint-plugin-react-refresh": "0.5.5",
    "globals": "17.12.0",
    "husky": "9.1.7",
    "jsdom": "^30.0.1",
    "lint-staged": "17.4.1",
    "prettier": "3.9.6",
    "terser": "5.51.2",
    "tw-animate-css": "1.4.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.69.0",
    "vite": "8.2.2",
    "vitest": "^4.1.11"
  },
  "lint-staged": {
    "*.{ts,tsx}": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.{js,jsx}": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.{json,md,css,scss}": [
      "prettier --write"
    ]
  }
}
